import { SvgIcon, SvgIconProps } from "@mui/material";
import { IconFacebookSvg } from "src/components/icons";

export const IconFacebook = (props: SvgIconProps) => (
    <SvgIcon sx={{ color: "#1877f2", ...props.sx }} viewBox="0 0 24 24">
        <IconFacebookSvg />
    </SvgIcon>
);
